import React, { useState, useEffect } from 'react';
import block from 'propmods';
import { DeviceLinkingInput } from '../DeviceLinkingInput/DeviceLinkingInput';
import { Loading } from '../Loading/Loading';
import { MarketDevice } from '../../model/devices';
import { useFetchingHandler } from '../../hooks/useFetchingHandler';
import { DeviceLinkingList } from '../DeviceLinkingList/DeviceLinkingList';
import { useCurrentAliceApp } from '../../hooks/useCurrentAliceApp';
import { devicesApi } from '../../api';
import { useSettingsPageContext } from '../../context/settingsPageContext';

import './DeviceLinking.scss';

const b = block('DeviceLinking');

export const DeviceLinking: React.FC = () => {
    const skill = useCurrentAliceApp()!;
    const { isDraft, isEditable } = useSettingsPageContext();
    const [devices, setDevices] = useState<MarketDevice[]>([]);

    const [fetchDevices, state] = useFetchingHandler({
        handler: () => devicesApi.getDeviceList(skill.id, skill.channel, isDraft),
        onLoad: (devices) => setDevices(devices),
    });

    useEffect(() => void fetchDevices(), []);

    const onDeviceAdd = (device: MarketDevice) => {
        setDevices([device, ...devices]);
    };

    const afterDeviceRemove = (deviceId: string) => {
        const newDevices = devices.filter((device) => device.marketId !== deviceId);

        setDevices(newDevices);
    };

    const disabled = !isEditable && !__appConfig.user.isAdmin;

    return (
        <div {...b()}>
            <div {...b('input')}>
                <DeviceLinkingInput onDeviceAdd={onDeviceAdd} disabled={disabled} devices={devices} />
            </div>
            {state === 'loading' ? (
                <Loading centered />
            ) : (
                <DeviceLinkingList devices={devices} afterDeviceRemove={afterDeviceRemove} disabled={disabled} />
            )}
        </div>
    );
};
